// extracted by mini-css-extract-plugin
export default {"container":"AdminProjectInfoCard_container__gmnMj"};